module.exports = __webpack_public_path__ + "uarm-images/map-with-a-location-pointer.svg";